import { popError } from "./Popup";

export function upload(
    page: string,
    type: string,
    file: File): Promise<string | false> {

    return new Promise(async (resolve) => {

        const form = new FormData();
        form.append('file', file);
        form.append('type', type);
        form.append('page', page);

        try {
            const resp = await fetch('/upload.php', {
                method: 'POST',
                credentials: 'include',
                body: form
            });
            const json = await resp.json();
            if( !json.ok ) {
                popError(json.data);
                resolve(false);
            }
            resolve(json.data);
        }
        catch (err) {
            console.error(err);
            resolve(false);
        }
    });
}
